export class SidePanel {
  private readonly block: string;
  private dom = {
    '$el': null,
    '$sidePanel': null,
    '$toggleButton': null,
    '$toggleButtonText': null,
    '$closeButton': null
  };

  constructor(selector: string) {
    this.block = selector;
    this.dom.$el = document.querySelector('.' + this.block) as HTMLElement;
  }

  /**
   * Initialize listeners
   * @private
   * @returns {void}
   */
  private _initListeners () {
    this.dom.$sidePanel = this.dom.$el.querySelector('#sidePanel') as HTMLDivElement;
    this.dom.$toggleButton = this.dom.$el.querySelector('#toggleSidePanel') as HTMLButtonElement;
    this.dom.$toggleButtonText = this.dom.$el.querySelector('#toggleSidePanel .side-panel__toggle-button--text') as HTMLSpanElement;
    this.dom.$closeButton = this.dom.$el.querySelector('#closeSidePanel') as HTMLButtonElement;

    // Toggle side panel
    if (this.dom.$toggleButton && this.dom.$sidePanel && this.dom.$closeButton) {

      // Make the side panel peek out on init, 1.5s delay for desktop
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;
      if (isDesktop && this.dom.$sidePanel && this.dom.$toggleButton) {
        this.dom.$sidePanel.classList.add('open');
        this.dom.$toggleButton.classList.add('open');

        setTimeout(() => {
          this.dom.$sidePanel!.classList.remove('open');
          this.dom.$toggleButton!.classList.remove('open');
        }, 1500);
      }

      // Toggle button
      this.dom.$toggleButton.addEventListener('click', () => {
        const isOpen = this.dom.$toggleButton!.classList.toggle('open');
        this.dom.$sidePanel!.classList.toggle('open');
        this.dom.$sidePanel!.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      // Close button
      this.dom.$closeButton.addEventListener('click', () => {
        this.dom.$toggleButton!.classList.remove('open');
        this.dom.$sidePanel!.classList.remove('open');
        this.dom.$sidePanel!.setAttribute('aria-expanded', 'false');
      });

    } else {
      console.error('Error: Elements not found within the specified block.');
    }

    // Close side panel when clicking outside of it
    document.addEventListener('click', (e) => {
      if (this.dom.$sidePanel!.classList.contains('open') && !this.dom.$el!.contains(e.target as Node)) {
        this.dom.$toggleButton!.classList.remove('open');
        this.dom.$sidePanel!.classList.remove('open');
        this.dom.$sidePanel!.setAttribute('aria-expanded', 'false');
      }
    });

    // Update toggle button text when side panel is opened/closed
    this.dom.$sidePanel!.addEventListener('transitionend', () => {
      this._toggleButtonText();
    });
  }

  /**
   * Toggle button text based on the side panel state
   * data-toggle-text-{open|close} is used to store the text to be toggled
   * @private
   * @returns {void}
   */
  private _toggleButtonText(): void {
    if (this.dom.$toggleButton) {
      const openText = this.dom.$toggleButton.getAttribute('data-toggle-text-open');
      const closeText = this.dom.$toggleButton.getAttribute('data-toggle-text-close');
      const isOpen = this.dom.$toggleButton.classList.contains('open');

      if (isOpen && closeText) {
        this.dom.$toggleButtonText.innerHTML = closeText;
      } else if (openText) {
        this.dom.$toggleButtonText.innerHTML = openText;
      }
    }
  }

  public init(): void {
    if (!this.dom.$el) {
      return;
    }

    this._initListeners();
  }
}
